import { NavLink } from "react-router-dom";
import { Home, Disc3, Dices, Wallet, Trophy, IndianRupee } from "lucide-react";
import { useLang } from "../context/LangContext";

const items = [
  { to: "/app", icon: Home, key: "lobby", end: true, id: "lobby" },
  { to: "/app/spin", icon: Disc3, key: "spin", id: "spin" },
  { to: "/app/dice", icon: Dices, key: "diceGame", id: "dice" },
  { to: "/app/payments", icon: IndianRupee, key: "payments", id: "payments" },
  { to: "/app/wallet", icon: Wallet, key: "wallet", id: "wallet" },
  { to: "/app/leaderboard", icon: Trophy, key: "leaderboard", id: "leaderboard" },
];

export default function BottomBar() {
  const { t } = useLang();
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#151824]/95 backdrop-blur-lg border-t border-amber-500/20 px-2 py-1.5 flex justify-around items-center">
      {items.map((it) => (
        <NavLink
          key={it.id}
          to={it.to}
          end={it.end}
          data-testid={`bottombar-${it.id}`}
          className={({ isActive }) =>
            `flex flex-col items-center gap-0.5 px-1.5 py-1 rounded-lg text-[10px] font-semibold transition-colors ${
              isActive ? "text-amber-400" : "text-slate-400"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <it.icon size={19} className={isActive ? "drop-shadow-[0_0_6px_rgba(255,215,0,0.7)]" : ""} />
              <span className="truncate max-w-[56px]">{t(it.key)}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
